import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Typography } from '@material-ui/core';
import { FirebaseActionProps } from '../../connected/FirebaseActionCnn';
import CreateNewPassword from './CreateNewPassword';
import qmoLogo from '../../../scss/img/qmo_logo.png'

const firebaseResetPasswordMode = "resetPassword"
const OOBCODE = "oobCode"


class FirebaseAction extends Component<FirebaseActionProps> {

    renderTitle = (title: string) => {
        return (
            <div style={{ textAlign: 'center', paddingTop: '25px', paddingBottom: '0px' }}>
                <img alt='' style={{ marginBottom: '30px', maxHeight: '200px' }} src={qmoLogo}></img>
                <Typography variant="h2">{title}</Typography>
            </div>
        )
    }

    renderMode = () => {
        var params = new URLSearchParams(this.props.history.location.search)
        let mode = params.get('mode')

        switch (mode) {
            case firebaseResetPasswordMode: {
                let oobCode = params.get(OOBCODE)

                return (
                    <div>
                        {this.renderTitle("Change password")}
                        <CreateNewPassword code={oobCode!} resetPasswordConfirm={this.props.resetPasswordConfirm} isBusy={this.props.resetPasswordConfirmBusy} message={this.props.resetPasswordConfirmMessage} success={this.props.resetPasswordConfirmSuccess} />
                    </div>
                )
            }
            default: {
                console.log('Not supported mode: ' + mode)
                this.props.history.push("/")
                break
            }
        }
    }

    render() {
        return (
            <div>
                {this.renderMode()}
            </div>
        );
    }
}

export default withRouter(FirebaseAction);